import { createDataConstants } from '../_constants';

export function createData(state = {}, action) {
    switch (action.type) {
      case createDataConstants.CREATE_NEW_DATA_REQUEST:
        return {
          loading: true
        };
      case createDataConstants.CREATE_NEW_DATA_SUCCESS:
        return {
          items: action.data
        };
      case createDataConstants.CREATE_NEW_DATA_FAILURE:
        return { 
          error: action.error
        };
      default:
        return state
    }
  }